import React, { useEffect } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useAuth0 } from "@auth0/auth0-react";
import { Config } from "../../Config";

// const LoginButton = () => {
//     return <button onClick={() => loginWithRedirect()}>Log In</button>;
// };

export const AuthenticatedContent: React.FC<{}> = ({ children }) => {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
        //  else if (!isLoading && isAuthenticated) {
        //     handleRedirectCallback().then(d => {
        //         console.log(d);
        //     });
        // }
    }, [isAuthenticated, isLoading, loginWithRedirect]);

    if (isLoading) return <div>...Loading</div>;

    if (!isAuthenticated) return null;

    return <>{children}</>;
};

export const BasicAuth: React.FC<{}> = ({ children }) => {
    if (!Config.protect) return <>{children}</>;

    return (
        <Auth0Provider
            domain={Config.auth0Domain}
            useRefreshTokens={true}
            maxAge={Config.auth0TokenExpiry}
            clientId={Config.auth0ClientId}
            redirectUri={window.location.origin}
        >
            <AuthenticatedContent>{children}</AuthenticatedContent>
        </Auth0Provider>
    );
};
